import React, { PropsWithChildren } from "react";

import useManageThemeWrapper from "./hooks/useManageThemeWrapper";

const ThemeWrapper = ({ children }: PropsWithChildren) => {
  const { styles } = useManageThemeWrapper();

  return <div style={styles}>{children}</div>;
};

export default ThemeWrapper;
